<div class="header__auth-wrapper">
  @if (auth.isLoggedInSignal()) {
    <button
      theme="plain"
      (click)="toggleAuthMenu()"
      htm-button
      class="header__auth-menu-toggle"
      #authMenuToggle
      data-test-id="header-auth-menu-toggle-button"
      >
      <span
        class="label--logged"
        [class.enterprise]="auth?.userData()?.role?.current_role?.type !== 'natural_person'"
        >
        <icon
          aria-hidden="true"
          glyph="user"
          class="icon-user medium"
        ></icon>
        <span class="header__auth-user">
          <b>
            @if (auth?.userData()?.role?.current_role?.type === 'natural_person') {
              @if (auth?.userData()?.firstname && auth?.userData()?.lastname) {
                {{ auth?.userData()?.firstname }} {{ auth?.userData()?.lastname}}
              } @else if (!auth?.userData()?.firstname && !auth?.userData()?.lastname) {
                {{ auth?.userData()?.username }}
              }
            } @else {
              {{ auth?.userData()?.role?.current_role?.data?.nimi }}
            }
          </b>
        </span>
        <icon
          aria-hidden="true"
          glyph="chevron-down"
          class="icon-chevron medium"
        ></icon>
      </span>
    </button>
    <user-modal/>
    @if (authMenuOpen()) {
      <div class="header__logout" #authMenu>
        <button htm-button theme="logout" (click)="handleOpenUserData()" data-test-id="header-auth-user-data-button" aria-haspopup="dialog">
          {{ 'frontpage.dashboard_tabs_personal_label' | translate | translate }}
        </button>
        <button htm-button theme="logout" (click)="handleLogout()" data-test-id="header-auth-logout-button">
          {{ 'button.logout' | translate }}
        </button>
      </div>
    }
  } @else {
    <ng-container [ngTemplateOutlet]="loggedOut"/>
  }
</div>
<ng-template #loggedOut>
  <button
    id="headerLogin"
    htm-button
    theme="plain"
    attr.aria-label="{{ 'button.login' | translate }}"
    data-test-id="header-auth-login-button"
    class="header__login"
    [class.active]="modalService.modalOpened()['login']"
    (click)="openLoginModal($event)"
    #loginButton
    >
    <icon
      aria-hidden="true"
      glyph="user"
      class="icon-user medium"
    ></icon>
    <span class="header__login-text">{{ "button.login" | translate }}</span>
  </button>
</ng-template>

<htm-modal
  id="login"
  modalTitle="{{ 'button.login' | translate }}"
  [bottomAction]="false"
  >
  <ng-template id="login">
    <alerts id="login-modal"></alerts>
    @if (loading) {
      <loader></loader>
    }
    <div class="login__methods">
      @if (!loading) {
        <div class="login__wrapper">
          @if (!mobileIdChallengeId) {
            @for (method of authMethods; track method; let first = $first) {
              @if (!first) {
                <labeled-separator
                  type="login"
                  label="{{ 'label.or' | translate }}"
                ></labeled-separator>
              }
              @if (method === 'harid') {
                <div class="login__method">
                  <button (click)="harIdLogin()" htm-button data-test-id="header-auth-harid-login-button">
                    {{ "login_harid" | translate }}
                  </button>
                </div>
              }
              @if (method === 'tara') {
                <div class="login__method">
                  <button (click)="taraLogin()" htm-button data-test-id="header-auth-tara-login-button">
                    {{ "login_tara" | translate }}
                  </button>
                </div>
              }
              @if (method === 'mobile_id') {
                <div class="login__method">
                  <div>
                    <h2>{{ "login_mobile" | translate }}</h2>
                  </div>
                  <div>
                    <form [formGroup]="mobileIdForm">
                      <formItem
                        ariaLabel="{{ 'dashboard.contactPhone' | translate }}"
                        formControlName="phoneNumber"
                        title="{{ 'dashboard.contactPhone' | translate }}"
                        testId="header-auth-mobile-id-phone-input"
                        >
                      </formItem>
                    </form>
                  </div>
                  <div>
                    <button (click)="mobileIdLogin()" htm-button data-test-id="header-auth-mobile-id-login-button">
                      {{ "button.login" | translate }}
                    </button>
                  </div>
                </div>
              }
              @if (method === 'basic') {
                <form
                  class="login__method"
                  [formGroup]="loginForm"
                  >
                  <div>
                    <formItem
                      ariaLabel="{{ 'login.username' | translate }}"
                      type="text"
                      formControlName="username"
                      browserAutocomplete="username"
                      title="{{ 'login.username' | translate }}"
                      testId="header-auth-basic-login-username-input"
                      >
                    </formItem>
                  </div>
                  <div>
                    <formItem
                      ariaLabel="{{ 'login.password' | translate }}"
                      type="password"
                      formControlName="password"
                      browserAutocomplete="password"
                      title="{{ 'login.password' | translate }}"
                      testId="header-auth-basic-login-password-input"
                      >
                    </formItem>
                  </div>
                  <div>
                    <button
                      (blur)="modalService.focusLock()"
                      htm-button
                      (click)="basicLogin()"
                      data-test-id="header-auth-basic-login-submit-button"
                      >
                      {{ "button.login" | translate }}
                    </button>
                  </div>
                </form>
              }
            }
          } @else {
            <div class="mobile-handshake">
              <p>{{ 'login.mobile_id_check' | translate }}</p>
              <h1>{{ this.mobileIdChallengeId }}</h1>
              <p class="mb-0">{{ 'login.mobile_id_pin1' | translate }}</p>
              <p class="mt-0">{{ 'login.mobile_id_waiting' | translate }}</p>
              <button (click)="mobileIdCancel()" htm-button theme="plain" data-test-id="header-auth-mobile-id-cancel-button">
                {{ 'button.cancel' | translate }}
              </button>
            </div>
          }
        </div>
      }
    </div>
  </ng-template>
</htm-modal>
